
import { TabContext } from "@mui/lab";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import { Paper, Tab, Typography } from "@mui/material";
import CashierList from './components/BilledListComponents/CashierList';
import PaidList from './components/BilledListComponents/PaidList';
import PendingPaymentList from './components/BilledListComponents/pendingPaymentList';
import { useSearchParams } from 'react-router-dom';
import { PaymentListProvider } from "./components/context/Listprovider";




const Indexv2 = () => {
    // const [tabValue, setTabValue] = useState("1");
     const [searchParams, setSearchParams] = useSearchParams();
      const tabValue = searchParams.get("tab") || "1";
    const handleChange = (_: any, newValue: string) => {
           setSearchParams({ tab: newValue });
    };
    return (
        <PaymentListProvider>

        <div className=' px-2'>
            <div className='flex justify-between p-2'>
                <Typography sx={(theme) => ({ fontWeight: "bold", color: theme.palette.primary.main })}>Cashier</Typography>
            </div>
            <Paper className="px-2 flex flex-col">
                <TabContext value={tabValue}>
                    <TabList className='border-b' onChange={handleChange} variant="fullWidth" aria-label="lab API tabs example">
                        <Tab label="Cashier" value="1" />
                        <Tab label="Paid List" value="2" />
                        <Tab label="Pending Payment/Ledger" value="3" />
        

                    </TabList>
                    <div className="flex-1 overflow-auto">
                        <TabPanel value="1">
                            <CashierList />
                        </TabPanel>
                        <TabPanel value="2">
                            <PaidList />
                        </TabPanel>
                        <TabPanel value="3">
                            <PendingPaymentList />
                        </TabPanel>
                       
                    </div>
                </TabContext>
            </Paper>
        </div>
        </PaymentListProvider>
    );
};

export default Indexv2;
